/**
 * @directive sgWidget
 * version: 0.0.1
 * description: Main directive used to initialize the sgWidget component.
 *
 */

'use strict';

(function() {
  angular
    .module('specsguardApp')
    .directive('sgWidgetContainer', sgWidgetContainer);

  function sgWidgetContainer () {
    return {
      restrict: 'E',
      templateUrl: 'app-legacy/components/sg-widget/sg-widget-container.tmpl.html',
      controller: 'sgWidgetContainerCtrl',
      controllerAs: '$sgWidgetContainerCtrl',
      bindToController: {
        widgets: '=',
      }
    };
  }
})();
